import { render, staticRenderFns } from "./surrenderEdit.vue?vue&type=template&id=3f4ea46d&scoped=true&"
import script from "./surrenderEdit.vue?vue&type=script&lang=js&"
export * from "./surrenderEdit.vue?vue&type=script&lang=js&"
import style0 from "./surrenderEdit.vue?vue&type=style&index=0&id=3f4ea46d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4ea46d",
  null
  
)

export default component.exports